import Vue from 'vue';

Vue.filter('pluralize', (value, single, plural) => {
  const num = Number(value);
  if (Number.isNaN(num)) return value;

  if (num === 1 || num === -1) return `${num} ${single}`;
  return `${num} ${plural}`;
});
